/* eslint-disable react/jsx-no-target-blank */
import React from "react";
import useLanguage from "../../hooks/language";

import styles from "./footer.module.css";

export const deployedVersion = (version: string | undefined): string => {
    const trimmed = version?.trim();
    if (!trimmed || trimmed.startsWith("PLACEHOLDER_")) {
        return "dev";
    }
    return trimmed;
};

const Footer: React.FunctionComponent = () => {
    const { translations } = useLanguage();
    const t = translations.footer;

    // Rendering

    return (
        <div className={styles.footerContainer}>
            <div className={styles.footer}>
                <div className={styles.row}>
                    <strong>{t.needHelp}</strong>
                    <a href="mailto:info@prelib.com">info@prelib.com</a>
                </div>
                <div className={styles.row}>
                    <a href={t.termsAndConditionsLink}>
                        {t.termsAndConditions}
                    </a>
                    <span>-</span>
                    <a href={t.privacyPolicyLink}>{t.privacyPolicy}</a>
                    <span>-</span>
                    <span>
                        {deployedVersion(process.env.REACT_APP_VERSION)}
                    </span>
                </div>
            </div>
        </div>
    );
};

export default Footer;
